var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('h3',{staticClass:"mr-5 w-20 flex-shrink-0 font-light text-Black60 md:mr-8 md:w-100px"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"flex-grow"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }